// Lightweight dev-only logger. No-op in production builds to avoid leaking
// internal logic / noise. Keeps stack traces during development.
const isDev = process.env.NODE_ENV !== "production";

export function devError(message, err) {
  if (isDev) console.error(message, err);
}

export function devWarn(message, err) {
  if (isDev) console.warn(message, err);
}
